import { getViewer } from 'src/machete-redux';

/*
 * @param {string} byteString
 * @param {string} imageMimeType
 */
const byteStringToBlob = (byteString, imageMimeType) => {
  const int8Array = new Uint8Array(byteString.length);

  for (let i = 0; i < byteString.length; i += 1) {
    int8Array[i] = byteString.charCodeAt(i);
  }

  return new Blob([int8Array], { type: imageMimeType });
};

/*
 * @param {Element} canvas
 * @param {string} imageMimeType
 * @param {number} imageQuality
 */
const canvasToBlob = (canvas, imageMimeType, imageQuality) => {
  const dataUrl = canvas.toDataURL(imageMimeType, imageQuality);
  const byteString = atob(dataUrl.split(',')[1]);

  return byteStringToBlob(byteString, imageMimeType);
};

const getJobShareImage = () => {
  const screenshot = Hover.Machete.Utils.screenshot(getViewer().renderer);
  const imageWidth = 500;
  const ratio = imageWidth / screenshot.width;
  const canvas = document.createElement('canvas');
  const imageMimeType = 'image/png';
  const imageQuality = 1.0;

  canvas.width = imageWidth;
  canvas.height = screenshot.height * ratio;
  canvas
    .getContext('2d')
    .drawImage(screenshot, 0, 0, canvas.width, canvas.height);

  return canvasToBlob(canvas, imageMimeType, imageQuality);
};

export default {
  byteStringToBlob,
  canvasToBlob,
  getJobShareImage,
};
